import { i } from "../../util-b2b0dc25.js";
import { on as u } from "./dom.js";
const r = [], n = "@@clickoutsideContext";
let m, s = 0;
!i() && u(document, "mousedown", (t) => m = t);
!i() && u(document, "mouseup", (t) => {
  r.filter((e) => document.contains(e)).forEach((e) => e[n].documentHandler(t, m));
});
function d(t, e, a) {
  return function(o = {}, c = {}) {
    !a || !o.target || !c.target || t.contains(o.target) || t.contains(c.target) || t === o.target || (e.value.name && t[n].methodName ? e.value(c) : t[n].bindingFn && t[n].bindingFn(c));
  };
}
const v = {
  beforeMount(t, e, a) {
    r.push(t);
    const o = s++;
    t[n] = {
      id: o,
      documentHandler: d(t, e, a),
      methodName: e.value.name,
      bindingFn: e.value
    };
  },
  updated(t, e, a) {
    t[n].documentHandler = d(t, e, a), t[n].methodName = e.value.name, t[n].bindingFn = e.value;
  },
  unmounted(t) {
    let e = r.length;
    for (let a = 0; a < e; a++)
      if (r[a][n].id === t[n].id) {
        r.splice(a, 1);
        break;
      }
    delete t[n];
  }
};
export {
  v as default
};
